import type { RiskLevel, WorkflowState } from "../../lib/api/clinical";

export const WORKFLOW_LABELS: Record<WorkflowState, string> = {
  open: "待处理",
  reviewing: "评估中",
  intervening: "干预中",
  observing: "观察中",
  closed: "已闭环",
  cancelled: "已取消",
};

export const LEVEL_LABELS: Record<RiskLevel, string> = {
  low: "常规监测",
  medium: "今日评估",
  high: "立即处理",
  critical: "立即处理",
};

export function levelClass(level: RiskLevel): string {
  if (level === "high" || level === "critical") return "tier-immediate";
  if (level === "medium") return "tier-today";
  return "tier-routine";
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("zh-CN", { hour12: false });
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("zh-CN");
}

export function daysSince(value: string | null | undefined): number | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return Math.max(0, Math.round((Date.now() - date.getTime()) / 86_400_000));
}

export function asText(value: unknown): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  return "";
}

export function formField(form: FormData, name: string): string {
  const value = form.get(name);
  return typeof value === "string" ? value : "";
}

export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => {
      reject(new Error("读取文件失败"));
    };
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("文件内容无法解析"));
        return;
      }
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.readAsDataURL(file);
  });
}
